<template>
    <span v-if="address">
         ul. {{ address.street }} {{ address.buildingNumber }}/{{ address.flatNumber }}, 
        {{ address.postalCode }} {{ address.city }}, 
        {{ address.country }}
    </span>
</template>

<script>
export default {
    props: {
        address: Object
    }
}
</script> 